var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-left_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.883 21.782 3.666 32 24.13 52.465l4.27-4.27L15.195 34.99H59.51V29.01H15.195L28.4 15.804l-2.12-2.12c-1.166-1.165-2.134-2.12-2.15-2.12s-4.628 4.599-10.248 10.218",
    clipRule: "evenodd"
  })));
};
export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjg4MyAyMS43ODI0TDMuNjY1NTMgMzJMMjQuMTMwNyA1Mi40NjUxTDI4LjQwMTIgNDguMTk1OUwxNS4xOTQ2IDM0Ljk4ODlINTkuNTExVjI5LjAxMDlIMTUuMTk0NkwyOC40MDEyIDE1LjgwNEwyNi4yODEgMTMuNjg0NEMyNS4xMTQ5IDEyLjUxODcgMjQuMTQ3MiAxMS41NjQ5IDI0LjEzMDYgMTEuNTY0OUMyNC4xMTM5IDExLjU2NDkgMTkuNTAyNSAxNi4xNjI4IDEzLjg4MyAyMS43ODI0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";